var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurrency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.242 75.376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.721-52.409H26.156A3.587,3.587,0,0,0,30.1-56.351V-68.812a3.587,3.587,0,0,0-3.942-3.942H13.721a3.6,3.6,0,0,0-3.955,3.942v12.461A3.6,3.6,0,0,0,13.721-52.409ZM17-58.031a1.015,1.015,0,0,1-1.111-1.032c0-.569.344-.82.807-1.2A1.983,1.983,0,0,0,17.5-61.88a2.377,2.377,0,0,0-.026-.291h-.966a.71.71,0,0,1-.767-.714.693.693,0,0,1,.767-.7H17.2a4.6,4.6,0,0,1-.159-1.111c0-1.786,1.415-3.056,3.889-3.056a4.408,4.408,0,0,1,2.262.423,1.018,1.018,0,0,1,.529.926.842.842,0,0,1-.939.886c-.516,0-.741-.119-1.442-.119-1.111,0-1.68.5-1.68,1.27a3.588,3.588,0,0,0,.106.78h2.368a.686.686,0,0,1,.767.7.7.7,0,0,1-.767.714h-2.09a2.323,2.323,0,0,1,.04.463,2.022,2.022,0,0,1-.675,1.495H22.69a1.049,1.049,0,0,1,1.138,1.085,1.052,1.052,0,0,1-1.138,1.1Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.55cee59594425c8d517a5ac2b8d7d77f.svg";
export { ForwardRef as ReactComponent };